
export default {
    /**
     * Increase ajax requests count
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    addAjaxRequests({commit}, count) {
        commit("ADD_AJAX_REQUEST", count);
    },

    /**
     * Set system variable
     * @param name
     * @param val
     */
    setVar({commit}, payload)
    {
        // Store
        commit("SET_VARIABLE", {var: payload.var, val: payload.val});
    },

    /**
     * Set update time
     */
    setUpdateTime({commit}, tm)
    {
        // Store time
        commit("SET_LAST_UPDATE_TIME", tm);
    }
}
